import React, {useContext, useState, useEffect} from 'react';
import './Tickers.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import {
    DataGridPremium
} from '@mui/x-data-grid-premium';
import ManageTickersDialog from './ManageTickersDialog';
import DeleteTickersDialog from './DeleteTickersDialog';
import { getFormatDate } from '../../../utils/CommonUtilities';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getTickers) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getTickers()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Fermata' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function Tickers(props) {
    const auth = useContext(AuthContext);
    const { tickers, setTickers } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [tickersLoading, setTickersLoading] = useState(true);

    const [openManageTickersDialog, setOpenManageTickersDialog] = useState(false);
    const [openDeleteTickersDialog, setOpenDeleteTickersDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManageTickersDialog, getTickers), renderCell: (params) => ActionCell(params, handleOpenManageTickersDialog, handleOpenDeleteTickersDialog)},
        /* {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Numero Fermata', type: 'string', width: 150, align: 'right', headerAlign: 'right', valueGetter: (params) => params?.S}, */
        {field: 'titolo', headerClassName: 'header-cell titolo', headerName: 'Titolo', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'itdescription', headerClassName: 'header-cell descrizione', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'expireDate', headerClassName: 'header-cell expireDate', headerName: 'Data di scadenza', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => getFormatDate(params?.S)},
    ]

    useEffect(() => {
        if(!tickers.length){
            getTickers();
        }else{
            setTickersLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getTickers();
        }
    }, [props.city])

    const getTickers = async() => {
        try {
            setLoading(true);
            setTickersLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-tickers',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setTickers(response.data.dataToReturn);
            //setRows(response.data.dataToReturn);
            setTickersLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setTickersLoading(false);
            setLoading(false);
        }
    }

    const handleOpenManageTickersDialog = (action) => {
        setOpenManageTickersDialog(action)
    }
    const handleCloseManageTickersDialog = () => {
        setOpenManageTickersDialog(false);
    }

    const handleOpenDeleteTickersDialog = () => {
        setOpenDeleteTickersDialog(true);
    }   
    const handleCloseDeleteTickersDialog = () => {
        setOpenDeleteTickersDialog(false);
    }

    return (
        <div className='component-container tickers'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={tickers}
                        columns={columns}
                        className="tickers-table"
                        loading={tickersLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        //slots={{
                        //    toolbar: ()=>CustomToolbar(),
                        //}}
                    />
                </ThemeProvider>
            </div>
            <ManageTickersDialog {...{
                openManageTickersDialog,
                handleCloseManageTickersDialog,
                lastCellData,
                getTickers,
                city: props.city
            }}/>
            <DeleteTickersDialog {...{
                openDeleteTickersDialog,
                handleCloseDeleteTickersDialog,
                lastCellData,
                getTickers
            }}/>
        </div>
    )
}

export default Tickers